import { NextSeo } from 'next-seo'

import { schoolPartnershipPageSeo } from '@lib/seo'
import FirstFold from '@components/school-partnership/first-fold'
import Benefits from '@components/school-partnership/benefits'
import PreviousPartnerships from '@components/school-partnership/previous-partnerships'
import Testimonial from '@components/school-partnership/testimonials'
import Projects from '@components/school-partnership/projects'
import Footer from '@components/common/footer'
import Banner from '@components/school-partnership/banner'
import VideoFold from '@components/common/VideoFold'

const SchoolPartnership = () => {
  return (
    <>
      <NextSeo {...schoolPartnershipPageSeo} />
      <FirstFold />
      <Banner />
      <Benefits />
      <VideoFold />
      <PreviousPartnerships />
      <Testimonial />
      <Projects />
      <Footer />
    </>
  )
}

export default SchoolPartnership
